import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: inline-block;
`;

export const CurrentLanguage = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 80px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: all 0.2s;
    height: 35px;
    width: 35px;

    &:hover {
        background: #f5f5f5;
    }

    img {
        width: 20px;
        height: 15px;
        border-radius: 2px;
    }
`;

export const LanguageList = styled.div<{ isOpen: boolean }>`
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 4px;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    display: ${props => props.isOpen ? 'block' : 'none'};
    z-index: 1000;
`;

export const LanguageOption = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 12px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: background 0.2s;

    &:hover {
        background: #f5f5f5;
    }

    img {
        width: 20px;
        height: 15px;
        border-radius: 2px;
    }
`;
